/**
 * Dispute status enum
 */
export enum DisputeStatus {
  Open = 'open',
  UnderReview = 'under_review',
  Resolved = 'resolved'
}

/**
 * Dispute resolution enum
 */
export enum DisputeResolution {
  None = 'none',
  RefundToBuyer = 'refund_to_buyer',
  ReleaseToSeller = 'release_to_seller'
}

/**
 * Message visibility enum
 */
export enum MessageVisibility {
  AdminOnly = 'admin_only',
  BuyerOnly = 'buyer_only',
  SellerOnly = 'seller_only',
  BothParties = 'both_parties'
}

/**
 * Dispute interface
 */
export interface Dispute {
  id: string;
  transactionId: string;
  initiatedBy: string; // "Buyer" or "Seller"
  initiatorId: string;
  reason: string;
  status: DisputeStatus;
  resolution: DisputeResolution;
  resolvedBy?: string;
  resolutionNotes?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Dispute message interface
 */
export interface DisputeMessage {
  id: string;
  disputeId: string;
  senderId: string;
  senderName: string;
  senderRole: string; // "Buyer", "Seller", or "Admin"
  message: string;
  visibility: MessageVisibility;
  createdAt: string;
}

/**
 * Dispute statistics interface
 */
export interface DisputeStats {
  open: number;
  underReview: number;
  resolved: number;
}

/**
 * Create dispute request interface
 */
export interface CreateDisputeRequest {
  transactionId: string;
  reason: string;
  message?: string;
}

/**
 * Add dispute message request interface
 */
export interface AddDisputeMessageRequest {
  message: string;
  visibility?: MessageVisibility;
}

/**
 * Resolve dispute request interface
 */
export interface ResolveDisputeRequest {
  resolution: DisputeResolution;
  notes?: string;
}

/**
 * Dispute with messages response interface
 */
export interface DisputeWithMessages {
  dispute: Dispute;
  messages: DisputeMessage[];
}